import React from 'react';
export function EngagementPlan() {
  return <div data-id="element-3501">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-3502">
        Engagement Plan
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-3503">
        Configure your customer engagement strategies and workflows
      </p>

      <div className="space-y-6" data-id="element-3504">
        {/* Engagement Strategy */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3505">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-3506">
            Engagement Strategy
          </h2>
          <div className="space-y-4" data-id="element-3507">
            <div data-id="element-3508">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3509">
                Default Follow-up Cadence
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-3510">
                <option data-id="element-3511">Immediate (within 1 hour)</option>
                <option data-id="element-3512">Same Day (within 8 hours)</option>
                <option data-id="element-3513">Next Day</option>
                <option data-id="element-3514">Custom</option>
              </select>
            </div>
            <div data-id="element-3515">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3516">
                Maximum Follow-up Attempts
              </label>
              <input type="number" placeholder="3" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-3517" />
            </div>
          </div>
        </div>

        {/* Communication Channels */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3518">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-3519">
            Preferred Communication Channels
          </h2>
          <div className="space-y-3" data-id="element-3520">
            <label className="flex items-center" data-id="element-3521">
              <input type="checkbox" defaultChecked className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-3522" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-3523">WhatsApp</span>
            </label>
            <label className="flex items-center" data-id="element-3524">
              <input type="checkbox" defaultChecked className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-3525" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-3526">Phone Call</span>
            </label>
            <label className="flex items-center" data-id="element-3527">
              <input type="checkbox" className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-3528" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-3529">Email</span>
            </label>
            <label className="flex items-center" data-id="element-3530">
              <input type="checkbox" className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-3531" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-3532">SMS</span>
            </label>
          </div>
        </div>

        {/* Auto-Assignment Rules */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3533">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-3534">
            Lead Auto-Assignment
          </h2>
          <div className="space-y-4" data-id="element-3535">
            <div data-id="element-3536">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3537">
                Assignment Method
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-3538">
                <option data-id="element-3539">Round Robin</option>
                <option data-id="element-3540">Based on Availability</option>
                <option data-id="element-3541">Based on Performance</option>
                <option data-id="element-3542">Manual Assignment</option>
              </select>
            </div>
            <label className="flex items-center" data-id="element-3543">
              <input type="checkbox" defaultChecked className="w-4 h-4 text-blue-500 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-3544" />
              <span className="ml-3 text-sm text-gray-700" data-id="element-3545">
                Automatically assign hot leads to top performers
              </span>
            </label>
          </div>
        </div>

        <div className="flex justify-end" data-id="element-3546">
          <button className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors font-medium" data-id="element-3547">
            Save Changes
          </button>
        </div>
      </div>
    </div>;
}